module.exports = __webpack_public_path__ + "static/media/logo-transparent-white.36aced85.svg";